// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as Curry from "../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Array from "../../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../../utils/CSS.bs.js";
import * as Unicons$Showside from "../../icons/Unicons.bs.js";
import * as Category$Showside from "../../types/Category.bs.js";
import * as Scrollable$Showside from "../Scrollable.bs.js";
import * as DataAttribute$Showside from "../../utils/DataAttribute.bs.js";
import * as ReactDOMUtils$Showside from "../../utils/ReactDOMUtils.bs.js";
import * as UseDelayedHover$Showside from "../../hook/UseDelayedHover.bs.js";
import * as ViewportContext$Showside from "../../context/ViewportContext.bs.js";
import * as NavMenu__Context$Showside from "./NavMenu__Context.bs.js";
import * as EntrypointContext$Showside from "../../context/EntrypointContext.bs.js";
import * as UseSimulatedClick$Showside from "../../hook/UseSimulatedClick.bs.js";
import * as ConfigurationProvider$Showside from "../../context/ConfigurationProvider.bs.js";
function NavMenu__Sidebar$ActiveTabIndicator(Props) {
  var show = Props.show;
  var ctx = NavMenu__Context$Showside.use(undefined);
  var match = ctx.mode;
  var match$1 = ctx.mode;
  return React.createElement("div", {
    className: CSS$Showside.prefix(Cn.make(["absolute h-full top-0 z-0 transition motion-reduce:transition-none duration-150", match ? "bg-main" : "bg-transparent-to-primary", match$1 ? show ? "opacity-100" : "opacity-0" : show ? "opacity-5" : "opacity-0", ctx.mode === /* Hamburger */1 ? "-left-3 -right-3 border-l-2 border-accent" : "left-0 w-full"]))
  });
}
NavMenu__Sidebar$ActiveTabIndicator.displayName = "NavMenu__Sidebar.ActiveTabIndicator";
var ActiveTabIndicator = {
  make: NavMenu__Sidebar$ActiveTabIndicator
};
function NavMenu__Sidebar$Item(Props) {
  var index = Props.index;
  var category = Props.category;
  var link = Props.link;
  var isNestedOpt = Props.isNested;
  var isActiveOpt = Props.isActive;
  var isBoldOpt = Props.isBold;
  var isHoverDelayedOpt = Props.isHoverDelayed;
  var isNested = isNestedOpt !== undefined ? isNestedOpt : false;
  var isActive = isActiveOpt !== undefined ? isActiveOpt : false;
  var isBold = isBoldOpt !== undefined ? isBoldOpt : true;
  var isHoverDelayed = isHoverDelayedOpt !== undefined ? isHoverDelayedOpt : false;
  var ctx = NavMenu__Context$Showside.use(undefined);
  var match = EntrypointContext$Showside.use(undefined);
  var onPureCategoryClick = match.onPureCategoryClick;
  var trackEvent = match.trackEvent;
  var match$1 = ConfigurationProvider$Showside.use(undefined);
  var ref = React.useRef(null);
  var match$2 = ctx.mode;
  var match$3 = UseDelayedHover$Showside.useDelayedHover(isHoverDelayed, 50, match$2 || typeof link !== "number" ? undefined : function (param) {
    Curry._2(onPureCategoryClick, false, category);
  });
  var match$4 = UseSimulatedClick$Showside.useTouch(true, undefined, function (e) {
    Curry._2(onPureCategoryClick, undefined, category);
  });
  var match$5 = ctx.mode;
  var handleItemTouchStart = typeof link === "number" && !match$5 ? match$4.onTouchStart : undefined;
  var match$6 = ctx.mode;
  var handleItemTouchMove = typeof link === "number" && !match$6 ? match$4.onTouchMove : undefined;
  var match$7 = ctx.mode;
  var handleItemTouchEnd = typeof link === "number" && !match$7 ? match$4.onTouchEnd : undefined;
  var handleItemClick = function (e) {
    var match = ctx.mode;
    if (typeof link === "number" && match) {
      e.preventDefault();
    }
    var match$1 = ctx.mode;
    if (typeof link === "number") {
      if (match$1) {
        return Curry._2(onPureCategoryClick, undefined, category);
      }
    } else if (link.TAG === /* InternalLink */0) {
      return Curry._1(link._0, undefined);
    }
    Curry.app(trackEvent, ["menu:link clicked", undefined, category, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined]);
  };
  var href;
  href = typeof link === "number" ? Category$Showside.getCategoryLink(category) : link.TAG === /* InternalLink */0 ? undefined : link._0.href;
  var target;
  target = typeof link === "number" ? match$1.config.settings.openLinkInNewTab ? "_blank" : undefined : link.TAG === /* InternalLink */0 || !link._0.openInNewTab ? undefined : "_blank";
  var match$8 = ctx.mode;
  var match$9 = ctx.mode;
  var tmp = {
    ref: ReactDOMUtils$Showside.Ref.domRef(ref),
    className: CSS$Showside.prefix(Cn.make(["outline-none no-underline relative flex flex-row items-center group", isActive ? "z-2" : "z-1", isNested && ctx.mode === /* Hamburger */1 ? "pl-2" : "", !isNested && index !== 0 ? "mt-2" : "", isActive ? "text-accent" : "text-primary group-hover:text-accent", match$8 && !isNested ? "py-4" : "py-3", match$9 || link === /* NoLink */0 ? "" : "hover:underline"])),
    tabIndex: 0,
    onClick: handleItemClick,
    onMouseLeave: match$3.onMouseLeave
  };
  if (href !== undefined) {
    tmp.href = Caml_option.valFromOption(href);
  }
  if (target !== undefined) {
    tmp.target = Caml_option.valFromOption(target);
  }
  if (match$3.onMouseEnter !== undefined) {
    tmp.onMouseEnter = Caml_option.valFromOption(match$3.onMouseEnter);
  }
  if (handleItemTouchEnd !== undefined) {
    tmp.onTouchEnd = Caml_option.valFromOption(handleItemTouchEnd);
  }
  if (handleItemTouchMove !== undefined) {
    tmp.onTouchMove = Caml_option.valFromOption(handleItemTouchMove);
  }
  if (handleItemTouchStart !== undefined) {
    tmp.onTouchStart = Caml_option.valFromOption(handleItemTouchStart);
  }
  return React.createElement(DataAttribute$Showside.make, {
    dataTestId: "nav-menu-sidebar-item",
    children: React.createElement("li", undefined, React.createElement("a", tmp, React.createElement("div", {
      className: CSS$Showside.prefix("flex-grow")
    }, React.createElement("div", {
      className: CSS$Showside.prefix(Cn.make(["flex flex-col", "relative z-1", "truncate-lines truncate-lines-2 select-none", isNested ? "text-base" : "text-lg", !isNested && isBold ? "font-semibold" : "", isNested && !isActive && ctx.mode === /* Hamburger */1 ? "opacity-80" : ""]))
    }, React.createElement("div", undefined, category.title))), ctx.mode === /* Topbar */0 && link === /* NoLink */0 ? React.createElement("div", {
      className: CSS$Showside.prefix(Cn.make(["flex-shrink-0 mx-4 text-accent transition-opacity duration-300", isActive ? "opacity-100" : "opacity-0 group-hover:opacity-100"]))
    }, React.createElement(Unicons$Showside.UilAngleRightB.make, {
      size: /* Px */{
        _0: 18
      }
    })) : null, React.createElement(NavMenu__Sidebar$ActiveTabIndicator, {
      show: isActive
    })))
  });
}
NavMenu__Sidebar$Item.displayName = "NavMenu__Sidebar.Item";
var make = React.memo(NavMenu__Sidebar$Item);
var Item = {
  make: make
};
function NavMenu__Sidebar(Props) {
  var level = Props.level;
  var items = Props.items;
  var dataTestId = Props.dataTestId;
  var classNameOpt = Props.className;
  var style = Props.style;
  var className = classNameOpt !== undefined ? classNameOpt : "";
  ViewportContext$Showside.use(undefined);
  var ctx = NavMenu__Context$Showside.use(undefined);
  var isHoverDelayed = level > 1;
  var activeItems = React.useMemo(function () {
    return Belt_Option.mapWithDefault(Belt_Option.keep(items, function (items) {
      return items.length !== 0;
    }), [], function (items) {
      return Belt_Array.keep(items, function (item) {
        return Belt_Array.some(ctx.currentFullPath, function (c) {
          return c.id === item.category.id;
        });
      });
    });
  }, [ctx.currentFullPath]);
  var getIsActive = function (category) {
    return Belt_Option.mapWithDefault(Belt_Array.get(activeItems, activeItems.length - 1 | 0), false, function (item) {
      return item.category.id === category.id;
    });
  };
  return Belt_Option.mapWithDefault(Belt_Option.keep(items, function (items) {
    return items.length > 1;
  }), null, function (items) {
    var tmp = {
      className: Cn.make([className, CSS$Showside.prefix("flex flex-col relative")])
    };
    if (style !== undefined) {
      tmp.style = Caml_option.valFromOption(style);
    }
    var tmp$1 = {
      children: React.createElement("ul", {
        className: CSS$Showside.prefix("list-none flex-shrink-0 w-full")
      }, Belt_Array.mapWithIndex(Belt_Array.keep(Belt_Array.keep(items, function (item) {
        return !item.isHidden;
      }), function (item) {
        if (item.isNested) {
          return !ctx.threeColumnLayout;
        } else {
          return true;
        }
      }), function (index, param) {
        var category = param.category;
        return React.createElement(make, {
          index: index,
          category: category,
          link: param.link,
          isNested: param.isNested,
          isActive: getIsActive(category),
          isBold: level === 1 || index === 0,
          isHoverDelayed: isHoverDelayed,
          key: category.id
        });
      }))
    };
    if (dataTestId !== undefined) {
      tmp$1.dataTestId = Caml_option.valFromOption(dataTestId);
    }
    return React.createElement("div", tmp, React.createElement(Scrollable$Showside.make, {
      children: React.createElement(DataAttribute$Showside.make, tmp$1),
      className: CSS$Showside.prefix(Cn.make(["relative h-full no-scrollbar", ctx.mode === /* Topbar */0 ? "pt-6 pl-4 pb-20" : "px-3"])),
      rememberScrollPosition: false
    }), ctx.mode === /* Hamburger */1 ? React.createElement(React.Fragment, undefined, React.createElement("div", {
      className: CSS$Showside.prefix("absolute inset-0 bg-primary opacity-5 -z-1")
    }), React.createElement("div", {
      className: CSS$Showside.prefix("absolute inset-0 opacity-5 -z-1 border-r border-primary")
    })) : React.createElement("div", {
      className: CSS$Showside.prefix("absolute inset-0 opacity-5 -z-1 border-r border-primary")
    }));
  });
}
NavMenu__Sidebar.displayName = "NavMenu__Sidebar";
var make$1 = React.memo(NavMenu__Sidebar);
var hoverDelay = 50;
export { hoverDelay, ActiveTabIndicator, Item, make$1 as make };
/* make Not a pure module */